module.exports = __webpack_public_path__ + "static/hermeus-47d31910f2245b43a716ab642f06949c.png";